const f = (t, l) => (t == null ? void 0 : t.filter((a, x) => l == null ? void 0 : l.includes(x))) ?? [];
export {
  f as extractByIndices
};
